export default __webpack_public_path__ + "media/img-3.bd40d7d3.png";